<template>
  <div class="user-records-page">
    <!-- 过滤控制栏 -->
    <div class="filter-controls">
      <select 
        v-model="filterType"
        class="type-selector"
        @change="handleFilterChange"
      >
        <option value="">选择记录类型</option>
        <option 
          v-for="type in typeOptions"
          :key="type"
          :value="type"
        >{{ type }}</option>
      </select>

      <select 
        v-model="filterUid"
        class="type-selector"
        @change="handleFilterChange"
      >
        <option value="">选择用户</option>
        <option 
          v-for="user in users"
          :key="user.username"
          :value="user.id"
        >{{ user.username }}</option>
      </select>
    </div>
    
    <!-- 数据表格 -->
    <div class="table-wrapper">
      <table class="data-table">
        <tbody>
          <tr v-for="(row, index) in tableData" :key="index">
            <td>
              <!-- 添加类型调试信息 -->
              <div class="row-header">用户：{{ row.username||'-' }}  类型: {{ row.types||'-' }}</div>
              <component
                :is="getComponentByType(row.types)"
                :tableData="formatDataContent(row.types,row.data)"
                :type="row.types"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <!-- 分页组件 -->
    <div class="custom-pagination">
      <div class="pagination-info">
        共 {{ pagination.total }} 条记录
      </div>
      <div class="pagination-controls">
        <select v-model="pagination.pageSize" @change="handleSizeChange" class="page-size-select">
          <option v-for="size in [10, 20, 50]" :key="size" :value="size">
            {{ size }} 条/页
          </option>
        </select>
        
        <button 
          class="page-btn" 
          :disabled="pagination.page === 1"
          @click="pagination.page > 1 && handlePageChange(pagination.page - 1)"
        >
          上一页
        </button>
        
        <span class="page-info">
          第 {{ pagination.page }} / {{ Math.ceil(pagination.total / pagination.pageSize) || 1 }} 页
        </span>
        
        <button 
          class="page-btn"
          :disabled="pagination.page >= Math.ceil(pagination.total / pagination.pageSize) || pagination.total === 0"
          @click="pagination.page < Math.ceil(pagination.total / pagination.pageSize) && handlePageChange(pagination.page + 1)"
        >
          下一页
        </button>
        
        <div class="page-jumper">
          <span>前往</span>
          <input 
            type="number" 
            min="1" 
            :max="Math.ceil(pagination.total / pagination.pageSize) || 1"
            v-model="jumpPage"
            @keypress.enter="goToPage"
            class="page-input"
          >
          <span>页</span>
          <button class="go-btn" @click="goToPage">确定</button>
        </div>
      </div>
    </div>
    
    <!-- 消息提示组件 -->
    <div v-if="message.show" class="message-toast" :class="message.type">
      {{ message.text }}
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import RecordsTable from '@/components/RecordsTable.vue';
import RecordTableXQ from '@/components/RecordTableXQ.vue';

export default {
 components: {
    RecordsTable,
    RecordTableXQ
  },
  data() {
    return {
      componentMap: {
        香草: 'RecordsTable',   // 香草类型对应 RecordsTable
        雪球: 'RecordTableXQ'  // 雪球类型对应 RecordTableXQ
      },
      tableData: [],
      filterType: '',
      filterUid: '',
      typeOptions: ['香草', '雪球','敲出雪球'], // 示例类型
      pagination: {
        page: 1,
        pageSize: 1,
        total: 0
      },
      jumpPage: 1,
      users: [], // 添加用户列表
      total_principal_label: '100w', // 定义 total_principal_label
      message: {
        show: false,
        text: '',
        type: 'success'
      }
    }
  },
  computed: {
    typeFilters() {
      return this.typeOptions.map(type => ({ text: type, value: type }))
    }
  },
  mounted() {
    this.fetchData();
    this.fetchCustomers();
  },
  methods: {
    // 显示消息提示
    showMessage(text, type = 'success') {
      this.message = { show: true, text, type };
      setTimeout(() => {
        this.message = { show: false, text: '', type: 'success' };
      }, 3000);
    },
    
   async fetchCustomers() {
      try {
        const res = await axios.get("/api/users", {
          headers: { 'Authorization': `Bearer ${this.$store.getters.token}` },
          params: {
            page: this.currentPage || 1,
            pageSize: this.pageSize || 100
          }
        });
        this.users = res.data; // 当前页的数据
        console.log('users', this.users);
        this.total = res.data.total; // 总记录数
      } catch (error) {
        console.error("获取客户列表失败:", error);
        this.showMessage("获取客户列表失败", 'error');
      }
    },
   // 根据类型返回组件名称
    getComponentByType(type) {
        if (!this.componentMap[type]) {
          console.warn(`未找到类型 ${type} 对应的组件，使用默认组件`);
        }
            return this.componentMap[type] || 'RecordsTable';
        },
    async fetchData() {
      try {
        const response = await axios.get('/api/user_records', {
          params: {
            page: this.pagination.page,
            page_size: this.pagination.pageSize,
            record_type: this.filterType || undefined,
            uid: this.filterUid || undefined
          },
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`
          }
        });

        this.tableData = response.data.data;
        console.log('tableData', this.tableData);
        this.pagination.total = response.data.total;
      } catch (error) {
        console.error('获取数据失败:', error);
        this.showMessage('数据加载失败', 'error');
      }
    },
    
    // 跳转到指定页
    goToPage() {
      let page = parseInt(this.jumpPage);
      const maxPage = Math.ceil(this.pagination.total / this.pagination.pageSize) || 1;
      if (page >= 1 && page <= maxPage) {
        this.handlePageChange(page);
      } else {
        this.jumpPage = this.pagination.page;
        this.showMessage(`页码超出范围，请输入1-${maxPage}之间的页码`, 'warning');
      }
    },

    // 类型标签样式
    getTagType(type) {
      const typeMap = {
        '香草': 'success',
        '雪球': 'warning',
        '障碍期权': 'danger',
        '鲨鱼鳍': 'info'
      }
      return typeMap[type] || '';
    },

    // 格式化JSON数据
    formatDataContent(types,data) {
        if (!data) {
            return '数据无效';
         }
         console.log('types', types);
         data = JSON.parse(data);
         if (types == '雪球') {
           return this.generateTableDataXQ(data);
         }else {
           return this.generateTableData(data);
         }
         // return this.generateTableData(data);
    },
    generateTableDataXQ(data) {
      const { date, stock_code, stock_name, stock_data_list } = data;


      const tableData = [
        // ... 你的 tableData 生成逻辑 ...
        { date, stock_code, stock_name, structure: '保底雪球',total_principal_label: this.total_principal_label, term: '70-100 6M', ...this.extractValuesXQ(stock_data_list, [2,20,99,99,99])},
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '70-103 6M', ...this.extractValuesXQ(stock_data_list, [3,21,99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-100 6M', ...this.extractValuesXQ(stock_data_list, [4,22,99,5,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-103 6M', ...this.extractValuesXQ(stock_data_list, [5,23,99,2,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-100 6M', ...this.extractValuesXQ(stock_data_list, [6,24,99,6,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-103 6M', ...this.extractValuesXQ(stock_data_list, [7,25,99,3,14]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '85-100 6M', ...this.extractValuesXQ(stock_data_list, [8,26,99,7,19]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '85-103 6M', ...this.extractValuesXQ(stock_data_list, [9,27,99,4,13]) },
        { date, stock_code, stock_name, structure: '保底雪球',total_principal_label: this.total_principal_label, term: '70-100 12M', ...this.extractValuesXQ(stock_data_list, [10,28,99,11,22]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '70-103 12M', ...this.extractValuesXQ(stock_data_list, [11,29,99,8,17]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-100 12M', ...this.extractValuesXQ(stock_data_list, [12,30,99,12,21]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-103 12M', ...this.extractValuesXQ(stock_data_list, [13,31,99,9,16]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-100 12M', ...this.extractValuesXQ(stock_data_list, [14,32,99,13,20]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-103 12M', ...this.extractValuesXQ(stock_data_list, [15,33,99,10,15]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '85-100 12M', ...this.extractValuesXQ(stock_data_list, [16,34,99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '85-103 12M', ...this.extractValuesXQ(stock_data_list, [17,35,99,99,99]) },

        { date, stock_code, stock_name, structure: '追保雪球',total_principal_label: this.total_principal_label, term: '70-100 6M', ...this.extractValuesXQ(stock_data_list, [18,3,99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '70-103 6M', ...this.extractValuesXQ(stock_data_list, [19,4,99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-100 6M', ...this.extractValuesXQ(stock_data_list, [20,5,99,17,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-103 6M', ...this.extractValuesXQ(stock_data_list, [21,6,99,14,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-100 6M', ...this.extractValuesXQ(stock_data_list, [22,7,99,18,9]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-103 6M', ...this.extractValuesXQ(stock_data_list, [23,8,99,15,4]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '85-100 6M', ...this.extractValuesXQ(stock_data_list, [24,9,99,19,8]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '85-103 6M', ...this.extractValuesXQ(stock_data_list, [25,10,99,16,3]) },
        { date, stock_code, stock_name, structure: '追保雪球',total_principal_label: this.total_principal_label,term: '70-100 12M', ...this.extractValuesXQ(stock_data_list, [26,11,99,23,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '70-103 12M', ...this.extractValuesXQ(stock_data_list, [27,12,99,20,7]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-100 12M', ...this.extractValuesXQ(stock_data_list, [28,13,99,24,11]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-103 12M', ...this.extractValuesXQ(stock_data_list, [29,14,99,21,6]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-100 12M', ...this.extractValuesXQ(stock_data_list, [30,15,99,25,10]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-103 12M', ...this.extractValuesXQ(stock_data_list, [31,16,99,22,5]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '85-100 12M', ...this.extractValuesXQ(stock_data_list, [32,17,99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '85-103 12M', ...this.extractValuesXQ(stock_data_list, [33,19,99,99,99]) },


        { date, stock_code, stock_name, structure: '折价建仓雪球',total_principal_label: this.total_principal_label, term: '70-100-80 6M', ...this.extractValuesXQ(stock_data_list, [99,37,99,99,23]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '70-103-80 6M', ...this.extractValuesXQ(stock_data_list, [99,38,99,99,24]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-100-85 6M', ...this.extractValuesXQ(stock_data_list, [99,39,99,99,25]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-103-85 6M', ...this.extractValuesXQ(stock_data_list, [99,40,99,99,26]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-100-90 6M', ...this.extractValuesXQ(stock_data_list, [99,41,99,99,27]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-103-90 6M', ...this.extractValuesXQ(stock_data_list, [99,42,99,99,28]) },
        { date, stock_code, stock_name, structure: '折价建仓雪球',total_principal_label: this.total_principal_label,term: '70-100-80 12M', ...this.extractValuesXQ(stock_data_list, [99,43,99,99,29]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '70-103-80 12M', ...this.extractValuesXQ(stock_data_list, [99,44,99,99,30]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-100-85 12M', ...this.extractValuesXQ(stock_data_list, [99,45,99,99,31]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-103-85 12M', ...this.extractValuesXQ(stock_data_list, [99,46,99,99,32]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-100-90 12M', ...this.extractValuesXQ(stock_data_list, [99,47,99,99,33]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-103-90 12M', ...this.extractValuesXQ(stock_data_list, [99,48,99,99,34]) },

      ];
       return tableData;

    },
    extractValuesXQ(stock_data_list, indices) {
      return {
        银河_雪球: (stock_data_list['银河_雪球'] != null && stock_data_list['银河_雪球'][indices[0]] !== undefined) ? stock_data_list['银河_雪球'][indices[0]] : 0,
        中信_雪球: (stock_data_list['中信_雪球'] != null && stock_data_list['中信_雪球'][indices[1]] !== undefined) ? stock_data_list['中信_雪球'][indices[1]] : 0,
        中金_雪球: (stock_data_list['中金_雪球'] != null && stock_data_list['中金_雪球'][indices[2]] !== undefined) ? stock_data_list['中金_雪球'][indices[2]] : 0,
        浙期_雪球: (stock_data_list['浙期_雪球'] != null && stock_data_list['浙期_雪球'][indices[3]] !== undefined) ? stock_data_list['浙期_雪球'][indices[3]] : 0,
        国君_雪球: (stock_data_list['国君_雪球'] != null && stock_data_list['国君_雪球'][indices[4]] !== undefined) ? stock_data_list['国君_雪球'][indices[4]] : 0

      };
    },
     generateTableData(data) {
      const { date, stock_code, stock_name, stock_data_list } = data;

      const tableData = [
        // ... 你的 tableData 生成逻辑 ...
         { date, stock_code, stock_name, structure: '80%',total_principal_label: this.total_principal_label, term: '2W', ...this.extractValues(stock_data_list, [22, 99, 99, 99, 99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '1M', ...this.extractValues(stock_data_list, [23, 14, 99, 6, 99, 99,18,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '2M', ...this.extractValues(stock_data_list, [24, 15, 99, 7, 99, 99,19,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '3M', ...this.extractValues(stock_data_list, [25, 16, 99, 8, 99, 99,20,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '6M', ...this.extractValues(stock_data_list, [26, 17, 99, 9, 99, 99,21,99]) },

        { date:'', stock_code:'', stock_name:'', structure: '90%',total_principal_label: this.total_principal_label, term: '2W', ...this.extractValues(stock_data_list, [27, 99, 99, 99, 99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '1M', ...this.extractValues(stock_data_list, [28, 9, 99, 10, 99, 2,22,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '2M', ...this.extractValues(stock_data_list, [29, 10, 99, 11, 99, 8,23,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '3M', ...this.extractValues(stock_data_list, [30, 11, 99, 12, 99, 14,24,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '6M', ...this.extractValues(stock_data_list, [31, 12, 99, 13, 99, 20,25,99]) },


        { date:'', stock_code:'', stock_name:'', structure: '95%',total_principal_label: this.total_principal_label, term: '2W', ...this.extractValues(stock_data_list, [32, 99, 99, 99, 99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '1M', ...this.extractValues(stock_data_list, [33, 99, 99, 99, 25, 3,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '2M', ...this.extractValues(stock_data_list, [34, 99, 99, 99, 26, 9,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '3M', ...this.extractValues(stock_data_list, [35, 99, 99, 99, 27, 15,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '6M', ...this.extractValues(stock_data_list, [36, 99, 99, 99, 28, 21,99,99]) },


        { date:'', stock_code:'', stock_name:'', structure: '100%',total_principal_label: this.total_principal_label, term: '2W', ...this.extractValues(stock_data_list, [2, 99, 99, 99, 99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '1M', ...this.extractValues(stock_data_list, [3, 4, 2, 2, 3, 4,2,2]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '2M', ...this.extractValues(stock_data_list, [4, 5, 3, 3, 4, 10,3,3]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '3M', ...this.extractValues(stock_data_list, [5, 6, 4, 4, 5, 16,4,4]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '6M', ...this.extractValues(stock_data_list, [6, 7, 5, 5, 6, 22,5,7]) },
        { date: '', stock_code:'', stock_name:'', structure: '103%', total_principal_label: this.total_principal_label,term: '2W', ...this.extractValues(stock_data_list, [7, 99, 99, 99, 99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '1M', ...this.extractValues(stock_data_list, [8, 18, 99, 26, 7, 5,6,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '2M', ...this.extractValues(stock_data_list, [9, 19, 99, 27, 8, 11,7,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '3M', ...this.extractValues(stock_data_list, [10, 20, 99, 28, 9, 17,8,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '',  total_principal_label:'',term: '6M', ...this.extractValues(stock_data_list, [11, 21, 99, 29, 10, 23,9,99]) },
        { date:'', stock_code:'', stock_name:'', structure: '105%',  total_principal_label:this.total_principal_label,term: '2W', ...this.extractValues(stock_data_list, [12, 99, 99, 99, 99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '',total_principal_label:'', term: '1M', ...this.extractValues(stock_data_list, [13, 22, 7, 30, 11, 6,10,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '',total_principal_label:'', term: '2M', ...this.extractValues(stock_data_list, [14, 23, 8, 31, 12, 12,11,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '3M', ...this.extractValues(stock_data_list, [15, 24, 9, 32, 13, 18,12,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '',total_principal_label:'', term: '6M', ...this.extractValues(stock_data_list, [16, 25, 10, 33, 14, 24,13,99]) },
        { date:'', stock_code:'', stock_name:'', structure: '110%',total_principal_label:this.total_principal_label, term: '2W', ...this.extractValues(stock_data_list, [17, 99, 99, 99, 99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '',total_principal_label:'', term: '1M', ...this.extractValues(stock_data_list, [18, 26, 99, 34, 11, 6,14,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '',total_principal_label:'', term: '2M', ...this.extractValues(stock_data_list, [19, 27, 99, 35, 12, 12,15,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '',total_principal_label:'', term: '3M', ...this.extractValues(stock_data_list, [20, 28, 99, 36, 13, 18,16,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '',total_principal_label:'', term: '6M', ...this.extractValues(stock_data_list, [21, 29, 99, 37, 14, 24,17,99]) }
      ];
       return tableData;
    },
    extractValues(stock_data_list, indices) {
      return {
        银河: (stock_data_list['银河'] != null && stock_data_list['银河'][indices[0]] !== undefined) ? stock_data_list['银河'][indices[0]] : 0,
        华泰: (stock_data_list['华泰'] != null && stock_data_list['华泰'][indices[1]] !== undefined) ? stock_data_list['华泰'][indices[1]] : 0,
        中金: (stock_data_list['中金'] != null && stock_data_list['中金'][indices[2]] !== undefined) ? stock_data_list['中金'][indices[2]] : 0,
        中信: (stock_data_list['中信'] != null && stock_data_list['中信'][indices[3]] !== undefined) ? stock_data_list['中信'][indices[3]] : 0,
        永安: (stock_data_list['永安'] != null && stock_data_list['永安'][indices[4]] !== undefined) ? stock_data_list['永安'][indices[4]] : 0,
        浙期: (stock_data_list['浙期'] != null && stock_data_list['浙期'][indices[5]] !== undefined) ? stock_data_list['浙期'][indices[5]] : 0,
        国君: (stock_data_list['国君'] != null && stock_data_list['国君'][indices[6]] !== undefined) ? stock_data_list['国君'][indices[6]] : 0,
        广发: (stock_data_list['广发'] != null && stock_data_list['广发'][indices[7]] !== undefined) ? stock_data_list['广发'][indices[7]] : 0

      };
    },

    // 分页处理
    handlePageChange(newPage) {
      this.pagination.page = newPage;
      this.fetchData();
    },

    handleSizeChange(newSize) {
      this.pagination.pageSize = newSize;
      this.fetchData();
    },

    handleFilterChange() {
      this.pagination.page = 1;
      this.fetchData();
    },

    // 类型过滤方法
    filterTypeTag(value, row) {
      return row.types === value;
    }
  }
}
</script>

<style scoped>
/* 用户记录页面样式 */
.user-records-page {
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 过滤控制栏样式 */
.filter-controls {
  margin-bottom: 20px;
  display: flex;
  gap: 15px;
  align-items: center;
  flex-wrap: wrap;
}

.type-selector {
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 20px;
  background-color: #fff;
  font-size: 14px;
  color: #606266;
  min-width: 180px;
  cursor: pointer;
  transition: border-color 0.3s;
}

.type-selector:focus {
  outline: none;
  border-color: #409eff;
}

/* 表格样式 */
.table-wrapper {
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  margin-bottom: 20px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table td {
  padding: 0;
  border-bottom: 1px solid #e8e8e8;
}

.row-header {
  padding: 12px;
  background-color: #f8f9fa;
  font-weight: 500;
  color: #495057;
  border-bottom: 1px solid #e9ecef;
}

.data-content {
  margin: 0;
  font-family: Monaco, Consolas, Courier, monospace;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-all;
  padding: 12px;
}

/* 分页组件样式 */
.custom-pagination {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
}

.pagination-info {
  color: #606266;
  font-size: 14px;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.page-size-select {
  padding: 6px 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.page-btn {
  padding: 6px 16px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #fff;
  color: #606266;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.page-btn:hover:not(:disabled) {
  color: #409eff;
  border-color: #c6e2ff;
}

.page-btn:disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: #606266;
  min-width: 150px;
  text-align: center;
}

.page-jumper {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #606266;
}

.page-input {
  width: 60px;
  padding: 6px 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
}

.page-input:focus {
  outline: none;
  border-color: #409eff;
}

.go-btn {
  padding: 6px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #fff;
  color: #606266;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.go-btn:hover {
  color: #409eff;
  border-color: #c6e2ff;
}

/* 消息提示样式 */
.message-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 12px 20px;
  border-radius: 4px;
  color: #fff;
  z-index: 2000;
  animation: slideInRight 0.3s ease-out;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.message-toast.success {
  background-color: #67c23a;
}

.message-toast.error {
  background-color: #f56c6c;
}

.message-toast.warning {
  background-color: #e6a23c;
}

.message-toast.info {
  background-color: #909399;
}

/* 动画效果 */
@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .user-records-page {
    padding: 10px;
  }
  
  .filter-controls {
    flex-direction: column;
    align-items: stretch;
  }
  
  .type-selector {
    width: 100%;
    min-width: auto;
  }
  
  .table-wrapper {
    overflow-x: auto;
  }
  
  .custom-pagination {
    flex-direction: column;
    align-items: stretch;
  }
  
  .pagination-controls {
    justify-content: center;
  }
  
  .pagination-info {
    text-align: center;
  }
}
</style>
